import React, { useEffect, useState } from 'react';
import { Capacitor } from '@capacitor/core';
import { waitForLiveUpdateReady } from '../lib/liveUpdates';
import { tt } from "../i18n/tt";

const LOADING_STYLE = {
  position: 'fixed',
  inset: 0,
  zIndex: 2147483647,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '14px',
  background: '#ffffff',
  color: '#1f2937',
  fontFamily: '-apple-system, BlinkMacSystemFont, "Pretendard", "Segoe UI", sans-serif',
  textAlign: 'center',
  padding: '24px',
};

const SPINNER_STYLE = {
  width: '34px',
  height: '34px',
  border: '3px solid #e5e7eb',
  borderTopColor: '#3cb7a0',
  borderRadius: '50%',
  animation: 'laeebly-mobile-update-spin 0.9s linear infinite',
};

const isUpdaterAvailable = () =>
  Capacitor.isNativePlatform() && Capacitor.isPluginAvailable('CapacitorUpdater');

export function StartupLoadingScreen({ message = '앱을 준비하고 있습니다.' }) {
  return (
    <div role="status" aria-live="polite" style={LOADING_STYLE}>
      <style>{'@keyframes laeebly-mobile-update-spin{to{transform:rotate(360deg)}}'}</style>
      <div aria-hidden="true" style={SPINNER_STYLE} />
      <strong>{message}</strong>
      <span style={{ color: '#6b7280', fontSize: '14px' }}>
        {tt("a.4e31bcd0", "최신 화면을 확인하는 중입니다. 잠시만 기다려 주세요.")}
      </span>
    </div>
  );
}

/**
 * Keeps the native app covered until the first healthy route has acknowledged
 * the current bundle and any compatible OTA download has finished applying.
 * Web and old native binaries without the updater render immediately.
 */
export default function MobileUpdateStartupGate({ children }) {
  const shouldWait = isUpdaterAvailable();
  const [ready, setReady] = useState(!shouldWait);

  useEffect(() => {
    if (!shouldWait) return undefined;
    let active = true;
    waitForLiveUpdateReady().then(() => {
      if (active) setReady(true);
    });
    return () => {
      active = false;
    };
  }, [shouldWait]);

  return (
    <>
      {children}
      {shouldWait && !ready && <StartupLoadingScreen message="업데이트를 준비하고 있습니다." />}
    </>
  );
}
